<template>
  <div class="col-lg-6 animated fadeInRight">
    <div class="mail-box-header">
      <h2>Lista de Caixas Fechados</h2>

      <form>
        <div class="input-group">
          <tags-input
            :tags="searchLabelsForDisplay"
            placeholder="Insira uma label"
            :select="true"
            :select-items="availableSearchLabels"
            @on-select="addSearchLabel"
            @on-tags-changed="syncSearchLabels"
          >
            <template #select-item="slotProps">
              {{ slotProps.value }}
            </template>
          </tags-input>

          <div class="input-group-btn">
            <button
              type="button"
              class="btn btn-sm btn-primary"
              @click="searchAccountingCash"
              v-if="permissionRead"
            >
              <i class="fa fa-search"></i>
              Buscar
            </button>
          </div>
        </div>
      </form>
    </div>
    <div class="mail-box">
      <table class="table table-hover table-mail">
        <thead class="table-head">
          <tr>
            <th>Nome</th>
            <th>Labels</th>
            <th>Data de Abertura</th>
            <th></th>
          </tr>
        </thead>

        <tbody class="table-list">
          <tr v-for="(listItem, listIdx) in accountingList.list" :key="listIdx">
            <td>{{ listItem.name || listItem.user.fullName }}</td>
            <td>
              <div
                v-for="(label, index) in listItem.accounting.labels"
                :key="index"
              >
                <LabelInfo :label="label" />
              </div>
            </td>
            <td>{{ DateBR(listItem.accounting.openedDate) }}</td>
            <td class="list-command">
              <div class="form-check">
                <input
                  type="checkbox"
                  class="form-check-input"
                  v-model="accounting"
                  :value="listItem.accounting"
                />
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import LabelInfo from '../../../../components/labelInfo/LabelInfo';
export default {
  components: {
    LabelInfo,
  },
  props: {
    existentLabels: Array,
  },
  data() {
    return {
      searchForm: {
        form: {
          labels: [],
        },
        control: {},
      },
      accounting: [],

      accountingList: {
        originalList: [],
        list: [],
        control: {},
      },
    };
  },
  computed: {
    searchLabelsForDisplay() {
      return this.searchForm.form.labels.map((l) => l.value);
    },
    availableSearchLabels() {
      const selectedKeys = this.searchForm.form.labels.map((l) => l.key);
      return this.existentLabels.filter((l) => !selectedKeys.includes(l.key));
    },
    permissionRead() {
      return this.$store.getters['DATA-ACCESS/HasAccess'](
        'manager-accounting-cash',
        'READ',
      );
    },
    permissionUpdate() {
      return this.$store.getters['DATA-ACCESS/HasAccess'](
        'manager-accounting-cash',
        'UPDATE',
      );
    },
  },
  watch: {
    accounting(v) {
      this.$emit('set-linked', v);
    },

    'searchForm.form.label'() {
      this.searchAccountingCash();
    },
  },


  mounted() {
    this.ListAccountings();
  },
  methods: {
    addSearchLabel(item) {
      if (!this.searchForm.form.labels.find((l) => l.key === item.key)) {
        this.searchForm.form.labels.push(item);
      }
    },
    syncSearchLabels(tags) {
      this.searchForm.form.labels = this.existentLabels.filter((l) =>
        tags.includes(l.value),
      );
    },
    DateBR(dt) {
      return new Date(dt).toLocaleString('pt-br');
    },
    resetSelectedAccountings() {
      this.accounting = [];
    },
    updateMovement(movements) {
      this.form.movements = movements;
    },
    async ListAccountings() {
      if (!this.permissionRead) {
        return;
      }
      this.accounting = [];
      const accountingList = await this.$store.dispatch(
        'ACCOUNTING-CASH/ListAllClosed',
      );
      this.accountingList.originalList = accountingList;
      this.searchAccountingCash();
    },
    searchAccountingCash() {
      if (!this.permissionRead) {
        return;
      }
      if (!this.searchForm.form.labels[0]) {
        this.accountingList.list = this.accountingList.originalList;
        return;
      }

      const filteredLabels = this.searchForm.form.labels.map(
        label => label.key,
      );
      const listFiltered = this.accountingList.originalList.filter(
        item =>
          item.accounting.labels.findIndex(label =>
            filteredLabels.includes(String(label)),
          ) >= 0,
      );

      this.accountingList.list = listFiltered;
    },
  },
};
</script>